import React, {useState} from 'react'
import AOS from 'aos'
import Welcome from './components/Welcome/Welcome'
import FeatureOverview from './components/Features/FeatureOverview'
import About from './components//About'
import ProjectPreview from './components/ProjectPreview'

function Landing() {
  
  const [projectPreviews] = useState(
    [
     {
      title: "Real Estate", 
      title2: "Large Scale Listing Collection", 
      description: "Calculating reinvestment of distributions and other metrics",
      src: "assets/img/illustrations/australia_map.png",
      id: "realestate",
      features: [
        {
          iconpath: "Code/Error-circle.svg", 
          title: "Problem", 
          description: "To train an LLM the client needed large scale active and historical property listings in Australia"
        },
        {
          iconpath: "Code/Done-circle.svg", 
          title: "Solution", 
          description: "We created a custom solution via projection-aware geospatial iteration crawled major real estate sites and extracted 8 million records in a reliable manner"
        },
        {
          iconpath: "Clothes/Briefcase.svg", 
          title: "Result", 
          description: "Cleaned database with monthly up to date data"
        }
      ]
      },
      {
      title: "Mortgage Broker", 
      title2: "Bank Application Automation", 
      description: "Mortgage Broker Automation",
      src: "assets/img/illustrations/mortgage_broker.png",
      id: "mortgagebroker",
      features: [
        {
          iconpath: "Code/Error-circle.svg", 
          title: "Problem", 
          description: "Identifying the best mortgage offers for customers and supplying correct documents was a labor-intense and costly process, relying heavily on manual data entry and research."
        },
        {
          iconpath: "Code/Done-circle.svg", 
          title: "Solution", 
          description: "Implemented AI agents to fully automate mortgage application filling, retrieve offer data from major banks, and build a centralized structured customer database based on submitted documents."
        },
        {
          iconpath: "Clothes/Briefcase.svg", 
          title: "Result", 
          description: "Fully automatic pipeline to both interact with banks and clients, saving hours of manual labor and making the business scalable."
        }
      ]
      },
      {
        title: "Igramscraper", 
        title2: " Access Instagram Data", 
        description: "Download public Data from Instagram",
        src: "assets/img/photos/instagram_scraper.png",
        id: "igramscraper",
        url: "https://pypistats.org/packages/igramscraper",
        features: [
          {
            iconpath: "Devices/Camera.svg", 
            title: "Media", 
            description: "Downloads all photos and videos of public users"
          },
          {
            iconpath: "General/Heart.svg", 
            title: "Likes and Comments", 
            description: "Extracts media likes and comments to get deeper insights on selected posts or Instagram accounts"
          },
          {
            iconpath: "Communication/Group.svg", 
            title: "Followers", 
            description: "Extracts who is following and followed by whom"
          }
        ]
      },
      {
      title: "Stox Reader", 
      title2: " Adaptive Annual Reports", 
      description: "Read Annual Reports of all US Companies on Mobile and Desktop",
      src: "assets/img/illustrations/xbrl_reader_3.png",
      id: "agents",
      features: [
        {
          iconpath: "Devices/iPhone-X.svg", 
          title: "Mobile First", 
          description: "SEC filings can be hard to read especially on phones. Stox Reader converts reports to adaptive and appealing documents"
        },
        {
          iconpath: "Design/Magic.svg", 
          title: "Beautiful Layout", 
          description: "Better structured and designed for increased readability"
        },
        {
          iconpath: "Clothes/Briefcase.svg", 
          title: "Business Integration", 
          description: "Integrates Stox Reader into other applications and making SEC reports more accessible"
        }
      ]
      }
  ])

  AOS.init()
  
  return(
    <div>
      <Welcome/>
      <FeatureOverview/>
      {projectPreviews.map(preview => (
        <div>
        <ProjectPreview 
          src={preview.src} 
          title={preview.title} 
          title2={preview.title2} 
          subtitle={preview.subtitle} 
          url={preview.url}
          id={preview.id}
          features={preview.features}/>
          <br/>
          <br/>
          </div>
      ))}
      <About/>
    </div>
  );
}

export default Landing;
